export const COMMON_REQ = 'cris/region/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/region/COMMON_REQ_FAIL';

export const LOAD_REGIONS_SUCCESS = 'cris/region/LOAD_REGIONS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	regions: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_REGIONS_SUCCESS:
			const regions = action.payload.data.regions.map((item) => ({
				id: item.id,
				name: item.name,
				code: item.code,
				remark: item.remark || ''
			}));

			return {
				...state,
				isLoading: false,
				regions: regions
			};

		default:
			return state;
	}
}